export const ThirdPartyCostPaidBy = ({
    Turn: {
        id: 0,
        label: 'Amobee'
    },
    Market: {
        id: 1,
        label: 'Market'
    }
});